var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.index === 0
        ? _c("Step1", {
            attrs: { rowId: _vm.fissionId },
            on: { cancel: _vm.cancel, nextStep: _vm.nextStep },
          })
        : _vm._e(),
      _vm.index === 1
        ? _c("Step2", {
            attrs: { rowId: _vm.fissionId },
            on: { lastStep: _vm.lastStep, nextStep: _vm.nextStep },
          })
        : _vm._e(),
      _vm.index === 2
        ? _c("Step3", {
            attrs: { rowId: _vm.fissionId, layoutList: _vm.layoutList },
            on: { lastStep: _vm.lastStep, nextStep: _vm.nextStep },
          })
        : _vm._e(),
      _vm.index === 3
        ? _c("Step4", {
            attrs: { rowId: _vm.fissionId },
            on: { lastStep: _vm.lastStep, saved: _vm.saved },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }